<div class="steps-nav">
  <div class="indicators" *ngIf="showIndicator">
    <a class="indicator" *ngFor="let s of steps" [routerLink]="s.url" routerLinkActive="active-link">
      <div class="icon-top">
        <div class="icon">
          <i class="far fa-circle"><span class="num">{{s.num}}</span></i>
          <i class="fas fa-user-edit"></i>
        </div>
      </div>
      <div class="icon-center">
        <div class="icon">
          <i class="fas fa-check"></i>
          <i class="fas fa-spinner"></i>
        </div>
      </div>
      <span class="text">{{s.label}}</span>
    </a>
  </div>
</div>
<main>
  <router-outlet></router-outlet>
</main>